import { OptionalAmount } from "../components/Common/dtos/OptionalAmount";
import OrderDto from "../components/Common/dtos/OrderDto";
import { dateRangeFormat } from "../components/Common/Filters/DateRangePill";
import { HttpMethod } from "../components/Common/useFetch";
import { QueryOptions } from "../components/Common/useQuery";
import useUserOrEmployeeQuery from "../components/Common/useUserOrEmployeeQuery";
import { useUserOrKaEmployee } from "../components/UserAccess/useUserOrKaEmployee";
import { PaginatedResult, PaginationParams } from "./usePaginatedQuery";
import { asUtcDate, omitIfEmpty } from "../Utilities";

export interface OrderDisplayDto extends OrderDto {
  customerName: string;
  customerAccountNumber: string;
  totalRequested: OptionalAmount;
  totalDispensed: OptionalAmount;
  siteNames: string[];
  createdAt: string;
  completedAt?: string;
}

export interface OrderPaginationParams extends PaginationParams {
  completed: boolean;
  orderNumberFilter?: string;
  itemId?: string;
  siteIds?: string[];
  unassignedSites?: boolean;
  customerId?: string;
  startDate?: string;
  endDate?: string;
}

const useSearchOrders = (
  params: OrderPaginationParams,
  options?: QueryOptions<PaginatedResult<OrderDisplayDto>>
) => {
  const { selectedBusiness } = useUserOrKaEmployee();

  return useUserOrEmployeeQuery<PaginatedResult<OrderDisplayDto>>({
    path: `/api/businesses/${selectedBusiness?.id}/orders/search`,
    method: HttpMethod.POST,
    body: {
      ...params,
      orderNumberFilter: omitIfEmpty(params.orderNumberFilter),
      itemId: omitIfEmpty(params.itemId),
      customerId: omitIfEmpty(params.customerId),
      startDate: asUtcDate(params.startDate, dateRangeFormat),
      endDate: asUtcDate(params.endDate, dateRangeFormat),
    },
  }, options);
};

export default useSearchOrders;